<template>
  <div class="container d-flex align-items-center flex-column mt-1">
    <div class="maincontent-bg d-flex flex-column">
      <rule-header :value="ruleHeader"/>
      <rule-game :title="ruleTitle.payRate" :value="rulePayrate"/>
      <rule-game :title="ruleTitle.rule" :value="ruleGame"/>
      <rule-game :title="ruleTitle.player" :value="rulePlayer"/>
    </div>
  </div>
</template>

<script>
import Board from '../../assets/gamerule/brb/Board_1.png';
import Winlose from '../../assets/gamerule/brb/Win or lose-min.png';
import Frame from '../../assets/gamerule/brb/Frame-min.png';
import Confirm from '../../assets/gamerule/brb/Confirm_Green-min.png';
import Random from '../../assets/gamerule/brb/Random_Bule-min.png';

export default {
  name: 'rule_brb',
  data() {
    return {
      ruleHeader: {
        gameName: 'เป่ายิงฉุบล้มเจ้า (RPS)',
        boardImg: Board,
      },
      ruleTitle: {
        payRate: 'อัตราจ่าย',
        rule: 'กติกา',
        player: 'ผู้เล่น',
      },
      rulePayrate: [
        {
          type: 'text',
          text: 'อัตราจ่าย 1 : 0.97',
          class: 'ml-3',
        },
        {
          type: 'text',
          text: '(หากผู้เล่นลงเดิมพัน 100 บาท และได้รับ ชัยชนะ ผู้เล่นจะได้รับเงินจากการเดิมพัน 97 บาท)',
          class: 'ml-3',
        },
      ],
      ruleGame: [
        {
          type: 'text',
          text: 'อัตราการเดิมพันต่อรอบจะเท่ากับจำนวนเดิมพัน หน้าห้อง หนึ่งห้องจะมีผู้เล่นได้สูงสุด 7 คน และสามารถเริ่มเล่นได้ตั้งแต่เข้าห้อง ในแต่ละห้องสามารถมีเจ้ามือได้เพียง 1 คน เท่านั้น ซึ่งกติกาการเล่นมีอยู่เพียงแค่ 3 ข้อคือ ค้อนชนะกรรไกร กรรไกรชนะกระดาษและกระดาษชนะค้อน ถ้าหากเสมอกับเจ้า ผู้เล่นจะได้เงินคืนตามยอดที่เดิมพัน',
          class: 'ml-3',
        },
        {
          type: 'imageNoborder',
          image: Winlose,
          class: 'w-50',
        },
      ],
      rulePlayer: [
        {
          type: 'text',
          text: 'ผู้เล่นสามารถเลือก ค้อน กรรไกร หรือกระดาษตามที่ผู้เล่นต้องการ เมื่อผู้เล่นเลือกแล้วให้กดที่ปุ่ม " ยืนยัน "',
          class: 'ml-3',
        },
        {
          type: 'image',
          image: Frame,
          class: 'w-50',
        },
        {
          type: 'text',
          text: 'หากผู้เล่นกดปุ่มสุ่ม เกมส์จะทำการสุ่มให้อัตโนมัติ  ว่าจะออกค้อน กรรไกร หรือกระดาษเมื่อสุ่มเสร็จสิ้นผู้เล่นต้องกดปุ่มยืนยัน เพื่ิอยืนยันตัวเลือกที่สุ่ม',
          class: 'ml-3',
        },
        {
          type: 'twoImage',
          image: Confirm,
          class: 'w-50',
          image2: Random,
        },
      ],

    };
  },
};
</script>
